import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { getEnterpriseTags, updateEnterprise } from '../../api/constlink';
import { RootState } from '../../modules';
import { Enterprise, Tag } from '../../modules/auth';
import SelectAddressModal from '../../components/auth/SelectAddressModal';
import MyEnterpriseEditComponent from '../../components/auth/MyEnterpriseEditComponent';
interface MyEnterpriseEditContainerProps {
  enterpriseId: string;
}
function MyEnterpriseEditContainer({
  history,
  match,
}: RouteComponentProps<MyEnterpriseEditContainerProps>) {
  const { enterpriseId } = match.params;
  const [gongjongs, setGongjongs] = useState<Tag[]>();
  const [subcontractTypes, setSubcontractTypes] = useState<Tag[]>();
  const myEnterprise = useSelector(
    (state: RootState) => state.auth.myEnterprise.data,
  );
  const [myEnterpriseData, setMyEnterpriseData] = useState<any>();
  const [updatedAddress, setUpdatedAddress] = useState<any>();
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    /**
     * typeorm error 로 인해 임시로 추가함
     * https://github.com/typeorm/typeorm/issues/9390
     */
    if (myEnterprise?.type2 === null) myEnterprise.type2 = [];
    if (myEnterprise?.workPerformed === null) myEnterprise.workPerformed = [];
    if (myEnterprise?.region === null) myEnterprise.region = [];

    setMyEnterpriseData({ ...myEnterprise });

    (async () => {
      setGongjongs(await getEnterpriseTags('gongjong'));
    })();
    (async () => {
      setSubcontractTypes(await getEnterpriseTags('subcontractType'));
    })();
  }, [enterpriseId, myEnterprise]);

  const onCreate = async (enterprise: Enterprise) => {
    await updateEnterprise({ enterpriseId, enterprise });
    history.push(`../myEnterprise?tab=1`);
  };

  const onCancel = () => history.goBack();

  const selectEnterpriseAddress = (value: any) => {
    setUpdatedAddress(value.address);
    setVisible(false);
  };

  const selectAddressModalOnCancel = () => setVisible(false);
  const openSelectAddressModal = () => setVisible(true);

  return (
    <>
      {myEnterpriseData && gongjongs && subcontractTypes && (
        // <EnterpriseCreateUpdateComponent
        //   onCreate={onCreate}
        //   onCancel={onCancel}
        //   enterprise={myEnterprise}
        //   gongjongs={gongjongs}
        //   materialVendorTypes={materialVendorTypes}
        //   uploadProps={uploadProps}
        // />
        <MyEnterpriseEditComponent
          data={myEnterpriseData}
          gongjongs={gongjongs}
          subcontractTypes={subcontractTypes}
          updatedAddress={updatedAddress}
          onCreate={onCreate}
          onPrev={onCancel}
          openSelectAddressModal={openSelectAddressModal}
        />
      )}

      {visible && (
        <SelectAddressModal
          selectAddress={selectEnterpriseAddress}
          onCancel={selectAddressModalOnCancel}
          visible={visible}
        />
      )}
    </>
  );
}

export default MyEnterpriseEditContainer;
